/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros 
Descripcion:        Navegacion del aplicativo
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import { Redirect, Route, Switch } from 'react-router-dom';
import LibroEfectiva from './pages/LibroEfectiva';

const App = () => {
    return (
        <Switch>
            <Route exact path="/"><Redirect to="/seguro" /></Route>
            <Route exact path="/seguro" component={LibroEfectiva} />
        </Switch>
    );
}

export default App;